export default __webpack_public_path__ + "static/form-default-values-do-ca158334798593d35fc1c8462851315281de08d2b45f61f51bba41124c9dd374.png";